import React, { useEffect } from 'react'
import useStores from '../../stores/useStore'
import { LinkContainer } from 'react-router-bootstrap'
import StyledNav from './StyledNav'
import styled from 'styled-components'
import { Nav, NavDropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { BiHelpCircle } from 'react-icons/bi'
const StyledNavWrapper = styled.div`
  height: 100%;
  margin-left: 0;
  font-weight: bold;
  font-size: 17px;

  .nav-pills .nav-link:not(.active),
  .nav-pills .dropdown-toggle:not(.active):not(.show) {
    background-color: transparent !important;
    color: inherit !important;
  }

  @media screen and (max-width: 767px) {
    position: absolute;
    background: #f6f6f6;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    height: 50px;
    top: 50px;
    left: 0;
    width: 100%;
  }
  .nav {
    flex-wrap: nowrap;
  }
`

const NavigationRight = ({ iconOnly = false }) => {
  const { uiStore, cwsStore } = useStores()
  const { t } = useTranslation()

  useEffect(() => {
    cwsStore.loadMenuItems()
  }, [cwsStore])

  // Combine all menu items into a single array
  const allMenuItems = [
    ...(cwsStore.menuItems || []).map((item) => ({
      id: item.id,
      displayName: item.displayName,
      path: `/custom-html/${item.id}`,
    })),
    ...(uiStore.articleCatalogAvailable
      ? [
          {
            id: 'articleCatalog',
            displayName: t('header:articleCatalog'),
            path: '/articleCatalog',
          },
        ]
      : []),
  ]

  const menuTitle = cwsStore.menuTitle || 'Services'

  const NavigationR = (
    <Nav variant='pills'>
      {allMenuItems.length > 1 ? (
        // Case 1: Multiple items, render a dropdown
        <NavDropdown
          title={
            iconOnly ? (
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='beratung-icon-tooltip'>{menuTitle}</Tooltip>
                }
              >
                <span>
                  <BiHelpCircle size={22} />
                </span>
              </OverlayTrigger>
            ) : (
              menuTitle
            )
          }
          active={uiStore.activeNav === 'advice-and-services'}
        >
          {allMenuItems.map((item) => (
            <LinkContainer to={item.path} key={item.id}>
              <NavDropdown.Item>{item.displayName}</NavDropdown.Item>
            </LinkContainer>
          ))}
        </NavDropdown>
      ) : allMenuItems.length === 1 ? (
        // Case 2: Exactly one item, render a single Nav.Link
        <LinkContainer to={allMenuItems[0].path}>
          <Nav.Link
            active={
              uiStore.activeNav === 'advice-and-services' ||
              uiStore.activeNav === 'article-catalog'
            }
          >
            {iconOnly ? (
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='single-menu-tooltip'>
                    {allMenuItems[0].displayName}
                  </Tooltip>
                }
              >
                <span>
                  <BiHelpCircle size={22} />
                </span>
              </OverlayTrigger>
            ) : (
              allMenuItems[0].displayName
            )}
          </Nav.Link>
        </LinkContainer>
      ) : null}
    </Nav>
  )

  return (
    <>
      <MediaQuery minWidth={1182}>
        <StyledNavWrapper>
          <StyledNav>{NavigationR}</StyledNav>
        </StyledNavWrapper>
      </MediaQuery>
      <MediaQuery maxWidth={1182}>{NavigationR}</MediaQuery>
    </>
  )
}

export default observer(NavigationRight)
